import React from 'react';
import { realValues, isCategorizedSkills, splitSkill, validCerts, certMeta } from './contactUtils';

/** Dark header bar, bold uppercase sections — premium executive look. */
export default function ExecutiveTemplate({ resume }) {
  if (!resume) return null;
  const c = resume.contact || {};

  return (
    <div style={{ fontFamily: '"Segoe UI", system-ui, sans-serif', maxWidth: '680px', margin: '0 auto', fontSize: '11px', lineHeight: '1.5', color: '#1a1a1a', background: '#fff' }}>
      {/* Dark header */}
      <div style={{ background: '#1a1a2e', color: '#fff', padding: '20px 28px 16px', marginBottom: '16px' }}>
        <div style={{ fontSize: '22px', fontWeight: '700', letterSpacing: '0.5px', marginBottom: '6px' }}>{c.name}</div>
        <div style={{ fontSize: '9px', color: '#aab4c8', display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {realValues([c.email, c.phone, c.location, c.linkedin]).map((v, i) => (
            <span key={i}>{v}</span>
          ))}
        </div>
      </div>

      <div style={{ padding: '0 28px 24px' }}>
        {resume.summary && (
          <Section title="PROFESSIONAL SUMMARY">
            <p style={{ margin: 0, color: '#333' }}>{resume.summary}</p>
          </Section>
        )}

        {resume.skills?.length > 0 && (
          <Section title="CORE COMPETENCIES">
            {isCategorizedSkills(resume.skills) ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', color: '#333' }}>
                {resume.skills.map((s, i) => {
                  const { label, rest } = splitSkill(s);
                  return <div key={i}>{label ? <><strong>{label}:</strong> {rest}</> : <>•&nbsp;{s}</>}</div>;
                })}
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', columnGap: '14px', rowGap: '2px' }}>
                {resume.skills.map((s, i) => <span key={i}>•&nbsp;{s}</span>)}
              </div>
            )}
          </Section>
        )}

        {resume.experience?.length > 0 && (
          <Section title="PROFESSIONAL EXPERIENCE">
            {resume.experience.map((exp, i) => (
              <div key={i} style={{ marginBottom: '11px' }}>
                <div style={{ fontWeight: '700', fontSize: '11.5px' }}>{exp.company}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                  <span style={{ color: '#1a1a2e', fontStyle: 'italic', fontSize: '10.5px' }}>{exp.title}</span>
                  <span style={{ fontSize: '9.5px', color: '#666' }}>{exp.dates}</span>
                </div>
                <ul style={{ margin: 0, paddingLeft: '14px' }}>
                  {exp.bullets?.map((b, j) => (
                    <li key={j} style={{ marginBottom: '2px', color: '#333' }}>{b}</li>
                  ))}
                </ul>
              </div>
            ))}
          </Section>
        )}

        {resume.education?.length > 0 && (
          <Section title="EDUCATION">
            {resume.education.map((edu, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <div>
                  <span style={{ fontWeight: '600' }}>{edu.institution}</span>
                  <span style={{ color: '#555', marginLeft: '6px' }}>{edu.degree}</span>
                </div>
                <span style={{ color: '#666', fontSize: '9.5px' }}>{edu.dates}</span>
              </div>
            ))}
          </Section>
        )}

        {validCerts(resume).length > 0 && (
          <Section title="CERTIFICATIONS">
            {validCerts(resume).map((cert, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <span style={{ fontWeight: '600' }}>{cert.name}</span>
                <span style={{ color: '#666', fontSize: '9.5px' }}>{certMeta(cert)}</span>
              </div>
            ))}
          </Section>
        )}
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '13px' }}>
      <div style={{ fontSize: '8.5px', fontWeight: '800', letterSpacing: '2px', color: '#1a1a2e', borderBottom: '2px solid #1a1a2e', paddingBottom: '3px', marginBottom: '7px', textTransform: 'uppercase' }}>{title}</div>
      {children}
    </div>
  );
}
